import authService from './authService';

export interface SubscriptionStatus {
  subscriptionStatus: 'active' | 'suspended' | 'canceled' | 'trial' | 'error';
  currentPeriodStart: string;
  currentPeriodEnd: string;
  remainingManDays: number;
  subscriptionId?: string;
  subscriptionName?: string;
  subscriptionNumber?: string;
  planName?: string;
  planCode?: string;
  customerName?: string;
  amount?: number;
  currencyCode?: string;
  currencySymbol?: string;
  nextBillingAt?: string;
  interval?: number;
  intervalUnit?: string;
  billingMode?: string;
  remainingBillingCycles?: number;
  createdAt?: string;
  activatedAt?: string;
}

class SubscriptionService {
  private baseURL: string;

  constructor() {
    this.baseURL = process.env.REACT_APP_API_URL || 'https://apidemo.pianat.ai';
  }

  /**
   * Fetch subscription status from backend
   * Uses the same authentication mechanism as authService
   */
  async getSubscriptionStatus(): Promise<SubscriptionStatus> {
    try {
      const response = await authService.apiCall(
        `${this.baseURL}/subscription/status`,
        {
          method: 'GET',
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch subscription status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching subscription status:', error);
      throw error;
    }
  }
}

export default new SubscriptionService();

